import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-classroom-downloads',
  templateUrl: './classroom-downloads.component.html',
  styleUrls: ['./classroom-downloads.component.scss']
})
export class ClassroomDownloadsComponent implements OnInit {

  @Input()
  subject;

  constructor() { }

  ngOnInit() {
  }

}
